import { render } from "./DownloadSection.vue?vue&type=template&id=74838b85&scoped=true"
const script = {}

import "./DownloadSection.vue?vue&type=style&index=0&id=74838b85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74838b85"]])

export default __exports__